import React, { ComponentType } from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { PATHS } from "./paths";
import { isLoggedIn, isConfigured } from "../utils/helpers";

interface IProps extends RouteProps {
	component: ComponentType<any>;
	status?: number;
	path: string;
}

function PrivateRoute(props: IProps): React.ReactElement {
	const { component: Component, ...rest } = props;

	const render = (props: any) => {
		if (!isLoggedIn()) {
			return <Redirect to={PATHS.LOGIN} />;
		} else if (isConfigured()) {
			return <Redirect to={PATHS.Home} />;
		}
		return <Component {...props} />;
	};

	return <Route {...rest} render={render} />;
}

export default PrivateRoute;
